import type { SxProps, Theme } from '@mui/material'
import { TableRow } from '@mui/material'
import type { ReactNode } from 'react'

interface ISimpleTableRowProps {
  children: ReactNode
  sx?: SxProps<Theme>
}

export default function SimpleTableRow({ children, sx }: ISimpleTableRowProps) {
  return <TableRow sx={sx}>{children}</TableRow>
}
